var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileLogoPersonalDataIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 98,
    viewBox: "0 0 97 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 28.4576C43.0505 28.4576 43.75 27.7581 43.75 26.8951C43.75 26.0321 43.0505 25.3326 42.1875 25.3326C41.3245 25.3326 40.625 26.0321 40.625 26.8951C40.625 27.7581 41.3245 28.4576 42.1875 28.4576Z",
    fill: "url(#paint0_linear_1239_10799)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6875 28.4576C55.5505 28.4576 56.25 27.7581 56.25 26.8951C56.25 26.0321 55.5505 25.3326 54.6875 25.3326C53.8245 25.3326 53.125 26.0321 53.125 26.8951C53.125 27.7581 53.8245 28.4576 54.6875 28.4576Z",
    fill: "url(#paint1_linear_1239_10799)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 34.7076H53.125C53.125 36.4311 51.7234 37.8326 50 37.8326H43.75V40.9576H50C53.4469 40.9576 56.25 38.1545 56.25 34.7076Z",
    fill: "url(#paint2_linear_1239_10799)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5437 59.842C76.0547 54.0326 70.5984 50.0685 64.3015 49.4951L57.4969 48.8764L56.7515 45.8951C59.8531 44.217 62.0546 41.0841 62.439 37.417L66.3406 36.117C69.6515 35.0123 71.875 31.9264 71.875 28.4373C71.875 27.1858 71.5796 25.9343 71.0202 24.817L70.4359 23.6499L71.0344 21.8529C71.5923 20.1841 71.875 18.4435 71.875 16.6826C71.875 7.66702 64.5406 0.332642 55.525 0.332642H41.3515C32.3344 0.332642 25 7.66702 25 16.6826C25 18.4435 25.2829 20.1826 25.8391 21.8529L26.4375 23.6499L25.8547 24.8155C25.2954 25.9343 25 27.1858 25 28.4373C25 31.9264 27.2234 35.0123 30.5344 36.117L34.4359 37.4186C34.8203 41.0858 37.0219 44.2185 40.1235 45.8966L39.3781 48.878L32.5719 49.4966C26.2766 50.0701 20.8204 54.0343 18.3312 59.8436L13.464 71.2014C12.825 72.6935 12.5 74.2733 12.5 75.8983C12.5 82.4795 17.8531 87.8326 24.4344 87.8326H25V92.5201C25 95.1045 27.1031 97.2076 29.6875 97.2076H67.1875C69.7719 97.2076 71.875 95.1045 71.875 92.5201V87.8326H72.4406C79.0219 87.8326 84.375 82.4795 84.375 75.8983C84.375 74.2733 84.05 72.692 83.4094 71.1983L78.5437 59.842ZM40.3937 51.9233L45.2765 53.8764L42.636 55.8561L40.2812 51.9326L40.3937 51.9233ZM56.4813 51.9233L56.5923 51.9326L54.2375 55.8561L51.5969 53.8764L56.4813 51.9233ZM28.125 28.4373C28.125 27.6685 28.3062 26.9014 28.65 26.2155L29.8125 23.8904L28.8046 20.8655C28.3531 19.5139 28.125 18.1076 28.125 16.6826C28.125 9.39046 34.0579 3.45764 41.35 3.45764H55.5235C62.8171 3.45764 68.75 9.39046 68.75 16.6826C68.75 18.1076 68.5219 19.5139 68.0703 20.8655L67.0625 23.8904L68.225 26.2155C68.5688 26.8998 68.75 27.6685 68.75 28.4373C68.75 30.5795 67.3844 32.4733 65.3515 33.1514L62.5 34.1014V23.7701C62.5 21.1858 60.3969 19.0826 57.8125 19.0826H50C46.5531 19.0826 43.75 16.2795 43.75 12.8326H40.625C40.625 13.9514 40.8219 15.0264 41.1829 16.0218C37.3484 16.5155 34.375 19.803 34.375 23.7701V34.1014L31.5219 33.1498C29.4906 32.4733 28.125 30.5795 28.125 28.4373ZM37.5 36.2701V23.7701C37.5 21.1858 39.6031 19.0826 42.1875 19.0826H43.0188C44.7359 20.9999 47.2298 22.2076 50 22.2076H57.8125C58.6735 22.2076 59.375 22.9093 59.375 23.7701V36.2701C59.375 40.578 55.8704 44.0826 51.5625 44.0826H45.3125C41.0046 44.0826 37.5 40.578 37.5 36.2701ZM45.3125 47.2076H51.5625C52.3298 47.2076 53.0781 47.1264 53.8 46.9764L54.4031 49.3889L48.4375 51.7749L42.4719 49.3889L43.075 46.9764C43.7969 47.1264 44.5452 47.2076 45.3125 47.2076ZM59.375 84.7076C57.6516 84.7076 56.25 83.3061 56.25 81.5826C56.25 79.8593 57.6516 78.4576 59.375 78.4576H65.625V84.7076H59.375ZM62.5 75.3326H59.375V65.9576H60.9375C61.7985 65.9576 62.5 66.6576 62.5 67.5201V75.3326ZM56.25 76.2014C54.3906 77.2858 53.125 79.2795 53.125 81.5826H43.75C43.75 79.2795 42.4844 77.2858 40.625 76.2014V65.9576H56.25V76.2014ZM37.5 75.3326H34.375V67.5201C34.375 66.6576 35.0766 65.9576 35.9375 65.9576H37.5V75.3326ZM37.5 78.4576C39.2234 78.4576 40.625 79.8593 40.625 81.5826C40.625 83.3061 39.2234 84.7076 37.5 84.7076H31.25V78.4576H37.5ZM68.75 92.5201C68.75 93.3826 68.0485 94.0826 67.1875 94.0826H29.6875C28.8265 94.0826 28.125 93.3826 28.125 92.5201V87.8326H37.5C39.8031 87.8326 41.7969 86.567 42.8812 84.7076H53.9954C55.0796 86.567 57.0734 87.8326 59.3766 87.8326H68.7516V92.5201H68.75ZM72.4406 84.7076H68.75V78.4576H78.125V75.3326H71.875V65.9576H68.75V75.3326H65.625V67.5201C65.625 64.9358 63.5219 62.8326 60.9375 62.8326H35.9375C33.3531 62.8326 31.25 64.9358 31.25 67.5201V75.3326H28.125V65.9576H25V75.3326H18.75V78.4576H28.125V84.7076H24.4344C19.5766 84.7076 15.625 80.7561 15.625 75.8983C15.625 74.6983 15.8641 73.5311 16.3375 72.4279L21.2046 61.0701C23.2422 56.3186 27.7062 53.0749 32.8577 52.6061L36.8281 52.2451L41.7406 60.4326L48.4375 55.4108L55.1359 60.4341L60.0484 52.2466L64.0173 52.6076C69.1687 53.0764 73.6328 56.3201 75.6704 61.0718L80.5375 72.4295C81.011 73.5326 81.25 74.6998 81.25 75.8983C81.25 80.7561 77.2984 84.7076 72.4406 84.7076Z",
    fill: "url(#paint3_linear_1239_10799)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 53.4576H9.375V56.5826H6.25V53.4576Z",
    fill: "url(#paint4_linear_1239_10799)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 53.4576H3.125V56.5826H0V53.4576Z",
    fill: "url(#paint5_linear_1239_10799)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 56.5826H6.25V59.7076H3.125V56.5826Z",
    fill: "url(#paint6_linear_1239_10799)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 50.3326H6.25V53.4576H3.125V50.3326Z",
    fill: "url(#paint7_linear_1239_10799)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 3.45764H18.75V6.58264H15.625V3.45764Z",
    fill: "url(#paint8_linear_1239_10799)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 3.45764H12.5V6.58264H9.375V3.45764Z",
    fill: "url(#paint9_linear_1239_10799)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.58264H15.625V9.70764H12.5V6.58264Z",
    fill: "url(#paint10_linear_1239_10799)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.332642H15.625V3.45764H12.5V0.332642Z",
    fill: "url(#paint11_linear_1239_10799)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 19.0826C5.22812 19.0826 3.125 21.1858 3.125 23.7701C3.125 26.3545 5.22812 28.4576 7.8125 28.4576C10.3969 28.4576 12.5 26.3545 12.5 23.7701C12.5 21.1858 10.3969 19.0826 7.8125 19.0826ZM7.8125 25.3326C6.95156 25.3326 6.25 24.631 6.25 23.7701C6.25 22.9091 6.95156 22.2076 7.8125 22.2076C8.67344 22.2076 9.375 22.9091 9.375 23.7701C9.375 24.631 8.67344 25.3326 7.8125 25.3326Z",
    fill: "url(#paint12_linear_1239_10799)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 47.2076H25V37.8326H15.625V47.2076ZM18.75 40.9576H21.875V44.0826H18.75V40.9576Z",
    fill: "url(#paint13_linear_1239_10799)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 53.4576H90.625V56.5826H87.5V53.4576Z",
    fill: "url(#paint14_linear_1239_10799)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.75 53.4576H96.875V56.5826H93.75V53.4576Z",
    fill: "url(#paint15_linear_1239_10799)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M90.625 56.5826H93.75V59.7076H90.625V56.5826Z",
    fill: "url(#paint16_linear_1239_10799)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.625 50.3326H93.75V53.4576H90.625V50.3326Z",
    fill: "url(#paint17_linear_1239_10799)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71.875 3.45764H75V6.58264H71.875V3.45764Z",
    fill: "url(#paint18_linear_1239_10799)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.125 3.45764H81.25V6.58264H78.125V3.45764Z",
    fill: "url(#paint19_linear_1239_10799)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75 6.58264H78.125V9.70764H75V6.58264Z",
    fill: "url(#paint20_linear_1239_10799)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M75 0.332642H78.125V3.45764H75V0.332642Z",
    fill: "url(#paint21_linear_1239_10799)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1875 22.2076C94.7719 22.2076 96.875 20.1045 96.875 17.5201C96.875 14.9358 94.7719 12.8326 92.1875 12.8326C89.6031 12.8326 87.5 14.9358 87.5 17.5201C87.5 20.1045 89.6031 22.2076 92.1875 22.2076ZM92.1875 15.9576C93.0484 15.9576 93.75 16.6591 93.75 17.5201C93.75 18.381 93.0484 19.0826 92.1875 19.0826C91.3265 19.0826 90.625 18.381 90.625 17.5201C90.625 16.6591 91.3265 15.9576 92.1875 15.9576Z",
    fill: "url(#paint22_linear_1239_10799)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M75 37.8326H84.375V28.4576H75V37.8326ZM78.125 31.5826H81.25V34.7076H78.125V31.5826Z",
    fill: "url(#paint23_linear_1239_10799)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1239_10799",
    x1: 82.5,
    y1: 106.27,
    x2: 82.5,
    y2: -6.72986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogoPersonalDataIcon);
export default __webpack_public_path__ + "static/media/profile_logo_personal-data_icon.0e375a5682194c8a8260c445271b2bac.svg";
export { ForwardRef as ReactComponent };